import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Skeleton } from '@repo/ui/Skeleton';
export function Card() {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = css({
      position: "relative",
      flex: "1",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "1",
      height: {
        base: "[100px]",
        sm: "[120px]"
      },
      minWidth: {
        base: "[100px]",
        sm: "[150px]"
      },
      maxWidth: {
        base: "[150px]",
        sm: "[100%]"
      }
    });
    t1 = css({
      flex: "1",
      bg: "common.white",
      width: "[100%]",
      rounded: "md",
      border: "1px solid",
      borderColor: "neutral.lighter",
      px: {
        base: "3",
        sm: "3"
      },
      py: {
        base: "[0.75rem]",
        sm: "3"
      }
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton variant="circular" animation="pulse" css={{
      position: "absolute",
      top: {
        base: "[5px]",
        sm: "[8px]"
      },
      left: {
        base: "[5px]",
        sm: "[8px]"
      },
      width: "[22px]",
      height: "[22px]",
      bg: "neutral.lighter-2",
      border: "[2px solid white]",
      boxShadow: "[0 2px 6px 0 rgba(0, 95, 185, 0.30)]",
      zIndex: "[1]"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={t1}>{t2}<Skeleton variant="rectangular" animation="pulse" css={{
        position: "relative",
        flex: "1",
        rounded: "sm",
        height: "[100%]",
        bg: "neutral.lighter-2"
      }} /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <article aria-hidden="true" className={t0}>{t3}<Skeleton variant="rectangular" animation="pulse" css={{
        width: "[72px]",
        height: "[14px]",
        rounded: "sm",
        bg: "neutral.lighter-2"
      }} /></article>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}